import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { join, map } from 'lodash';
import { Link } from 'react-router-dom';
import { formatDate, formatMapNames } from '../../utils/Formatters';
import { isAdminDashboard, isChatEnabled } from '../../utils/authScopes';
import { isColumnOn } from '../helpers/TableHelpers';
import { appNamedRoutes } from '../../routes';
import { withTranslation } from 'react-i18next';

class AccountPlayersRow extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    data:  PropTypes.object.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    withPeriod: PropTypes.bool.isRequired,
    onAccountPlayer: PropTypes.func.isRequired,
  }

  onAccountPlayer = (e) => this.showAccountPlayer(e, 0)

  showAccountPlayer = (e, tab) => {
    e.stopPropagation();
    const { data, onAccountPlayer } = this.props;
    onAccountPlayer(data.id, tab);
  }

  render() {
    const { auth, data, options, withPeriod, t } = this.props;
    const clsMessages = classNames(
      { 'cs-txt-link--sp-blue': !data.hasUnreadMessages },
      { 'cs-txt-link--sp-red': data.hasUnreadMessages },
    );
    const lastAsqs = map(data.lastAsqs, asq =>
      <p className='u-margin-bottom--zero' key={asq.id}>
        {asq.name} <br/>
        {formatDate(asq.date)}
      </p>
    );
    return (
      <tr className='u-pointer' onClick={this.onAccountPlayer}>
        { isColumnOn(0, options) && <td>{data.id}</td> }
        <td>
          {data.name}<br />
          { isChatEnabled(auth) &&
            <Link
              className={clsMessages}
              to={{
                pathname: appNamedRoutes.communicationIndividuals,
                search: `?id=${data.id}`
              }}
              title={t('accountPlayer.coaching')}
              onClick={(e) => e.stopPropagation()}>
            <i className='fa fa-comments-o fa-border'></i>
            </Link>}
        </td>
        { isAdminDashboard(auth) && <td>{data.partner}</td> }
        { isColumnOn(1, options) && <td>{join(data.groups, ', ')}</td> }
        { isColumnOn(2, options) && <td>{formatMapNames(data.cohorts)}</td> }
        { isColumnOn(3, options) && <td>{data.creator.name}</td> }
        { isColumnOn(4, options) && <td>{data.ageRange}</td> }
        { isColumnOn(5, options) && <td>{data.locale}</td> }
        { isColumnOn(6, options) && <td>{formatDate(data.createdAt)}</td> }
        { isColumnOn(7, options) && <td>{formatDate(data.lastAppTouch)}</td> }
        { isColumnOn(8, options) && <td>{formatDate(data.lastActivity)}</td> }
        { isColumnOn(9, options) && <td>{data.totalPlays}</td> }
        { withPeriod && isColumnOn(10, options) && <td>{data.totalPlaysIn}</td> }
        { isColumnOn(11, options) && <td>{data.totalFreePlays}</td> }
        { withPeriod && isColumnOn(12, options) && <td>{data.totalFreePlaysIn}</td> }
        { isColumnOn(13, options) && <td>{data.totalPhotos}</td> }
        { withPeriod && isColumnOn(14, options) && <td>{data.totalPhotosIn}</td> }
        { isColumnOn(15, options) && <td>{data.cards.liked}</td> }
        { isColumnOn(16, options) && <td>{data.cards.notLiked}</td> }
        { isColumnOn(17, options) && <td>{data.cards.tooHard}</td> }
        { isColumnOn(18, options) && <td>{data.cards.tooEasy}</td> }
        { isColumnOn(19, options) && <td>{data.cards.justRight}</td> }
        { isColumnOn(20, options) && <td>{lastAsqs}</td> }
        { isColumnOn(21, options) && <td>{formatDate(data.lastMessageFrom)}</td> }
        { isColumnOn(22, options) && <td>{formatDate(data.lastMessageTo)}</td> }
      </tr>
    );
  }
}

export default withTranslation()(AccountPlayersRow);
